import React from "react";
import { useRemoteGitActionsContext } from "../contexts/RemoteGitActionsContext";
import styles from "../styles/GitLogsStyles";

const GitLogs = ({ limit = 5 }) => {
  const { gitLogs, clearLogs } = useRemoteGitActionsContext();

  if (!gitLogs || gitLogs.length === 0) {
    return null;
  }

  const recentLogs = gitLogs.slice(0, limit);

  return (
    <div style={styles.container}>
      <h4>Git Logs</h4>
      <button onClick={clearLogs} style={styles.clearButton}>
        Clear Logs
      </button>
      <ul style={styles.list}>
        {recentLogs.map((log, index) => (
          <li key={index} style={styles.listItem}>
            <div style={styles.logEntry}>
              <p>
                <strong>Author:</strong> {log.author}
              </p>
              <p>
                <strong>Commit ID:</strong> {log.commitId}
              </p>
              <p>
                <strong>Message:</strong> {log.commitMessage}
              </p>
              <p>
                <strong>Date:</strong> {new Date(log.date).toLocaleString()}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GitLogs;
